import { VoucherPrintOrgHeading, VoucherPrintOrgAddress } from "./VoucherPrintOrgHeader";
import PrintCommon from "app/common/Component/Print/PrintCommon";
import {
  format2NumberAtferComma,
  formatMoney,
  formatPrintPatientCodeSuffix,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import React, { memo, useEffect, useState } from "react";

const PrintTheServiceForm = ({
  componentRef,
  patientId,
  selectedItems,
  qrCode,
  voucherPaymentMethods,
}) => {
  const { dataVoucherFee } = useStore().feeStore.serviceFeeTabStore;
  const firstVoucher = dataVoucherFee?.content?.[0] || {};

  return (
    <PrintCommon ref={componentRef} marginPage="8mm" hidden={false}>
      <header className="printHeader w-100 flex justify-between">
        <table className="table-layout-fixed">
          <div className="wraper-print">
            <div className="container-print">
              <VoucherPrintOrgHeading department={firstVoucher?.department} />
              <VoucherPrintOrgAddress
                department={firstVoucher?.department}
                phonePrefix="Hotline: "
                addressClassName="adress-print"
              />

              <div className="mt-5 text-center">
                <h4 style={{ fontWeight: "bold" }}>HÓA ĐƠN TẠM TÍNH</h4>
                <div className="center">
                  {new Date()
                    .toLocaleString("vi-VN", {
                      hour12: false,
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                    .replace(",", "")}
                </div>
              </div>

              <table
                className="info-print"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        width: "20%",
                        fontWeight: "bold",
                        padding: "8px 0",
                      }}
                    >
                      KH:
                    </td>
                    <td style={{ width: "30%", padding: "8px 0" }}>
                      {firstVoucher?.patient?.displayName || ""}{" "}
                      {formatPrintPatientCodeSuffix(firstVoucher?.patient)}
                    </td>
                    {/* <td rowSpan="4" style={{ width: "50%", textAlign: "center", verticalAlign: "top" }}>
                            {firstVoucher && (
                                <CreditCard />
                            )}
                        </td> */}
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "8px 0" }}>
                      Ngày:
                    </td>
                    <td style={{ padding: "8px 0" }}>09/05/2025 12:12</td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "8px 0" }}>
                      Thu ngân:
                    </td>
                    <td style={{ padding: "8px 0" }}>
                      {firstVoucher?.accountant?.staffName || "Không rõ"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "8px 0" }}>
                      HĐ:
                    </td>
                    <td style={{ padding: "8px 0" }}>
                      {firstVoucher?.code || "Chưa có mã"}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table className="table-print">
                <thead className="thead-print">
                  <tr>
                    <th>SL</th>
                    <th>Đ.Giá</th>
                    <th>Thu Hiện Thời</th>
                  </tr>
                </thead>
                <tbody className="tbody-print">
                  {selectedItems?.length > 0 ? (
                    selectedItems?.map((it, index) => (
                      <React.Fragment key={it.id || index}>
                        <tr className="no-border">
                          <td colSpan={3} className="service-name-td">
                            {it?.invoiceItemName || "Không rõ"}
                          </td>
                        </tr>
                        <tr>
                          <td>{it?.quantity || 0}</td>
                          <td>
                            {format2NumberAtferComma(it?.currentFee || 0)}
                          </td>
                          <td>
                            {format2NumberAtferComma(
                              it?.currentPaymentAmount || 0
                            )}
                          </td>
                        </tr>
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3}>Không có dữ liệu</td>
                    </tr>
                  )}
                </tbody>
              </table>
              <table className="summary-table">
                <tbody>
                  <tr>
                    <td className="label-print">Tổng số lượng:</td>
                    <td className="value-print">
                      {selectedItems?.reduce(
                        (total, item) => total + (item?.quantity || 0),
                        0
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Tổng số tiền (VND):</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {selectedItems
                        ?.reduce(
                          (total, item) =>
                            total + (item?.currentPaymentAmount || 0),
                          0
                        )
                        .toLocaleString("vi-VN", {
                          style: "currency",
                          currency: "VND",
                        })}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Ghi chú:</td>
                    <td className="value-print">
                      {patientId?.note || "Không có ghi chú"}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">HTTT:</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {/* {listPaymentMethod?.[selectedRadioIndex]?.name || "Không xác định"}:{" "}
                      {(moneyAfterDiscount || 0).toLocaleString("vi-VN", {
                        style: "currency",
                        currency: "VND",
                      })} */}

                      <div>
                        {voucherPaymentMethods
                          ?.filter((el) => el?.totalOfMethod > 0)
                          ?.map((method, index) => {
                            const name = method?.paymentMethodValue?.name || "";
                            const amount = +method?.totalOfMethod ?? 0;
                            const bankAccountNumber =
                              method?.bankAccountNumber || "";
                            const bankName = method?.bankName || "";
                            return (
                              <>
                                <div
                                  key={index}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <span>
                                    {name && `${name}: `}
                                    <b>{formatMoney(amount)}</b>
                                  </span>
                                  {bankName && (
                                    <div>
                                      <span>
                                        Ngân hàng: <b>{bankName} </b>
                                        {bankAccountNumber && (
                                          <i
                                            style={{
                                              fontSize: "11px",
                                              fontWeight: "500",
                                            }}
                                          >
                                            stk:{bankAccountNumber}
                                          </i>
                                        )}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </>
                            );
                          })}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div style={{ textAlign: "center", fontSize: "14px" }}>
                <span>Chữ ký khách hàng</span>
                <div style={{ height: "150px" }}></div>
              </div>

              <div style={{ textAlign: "center" }}>
                <div style={{ textAlign: "center", fontSize: "15px" }}>
                  <span>
                    Trung tâm Thẩm mỹ sẽ không hoàn lại tiền nếu khách hàng yêu
                    cầu hủy dịch vụ. Vui lòng liên hệ nếu có nhu cầu chuyển
                    nhượng.
                  </span>
                </div>
                <div className="mt-2">
                  <span style={{ fontSize: "14px" }}>Cảm ơn quý khách!</span>
                </div>
              </div>
              <div className="flex flex-center">
                <img src={qrCode} style={{ width: "124px" }} alt="QrCode" />
              </div>
            </div>
          </div>
        </table>
      </header>
    </PrintCommon>
  );
};

export default memo(PrintTheServiceForm);
